import { render, staticRenderFns } from "./MuokkaaKoulutus.vue?vue&type=template&id=bc946c84&"
import script from "./MuokkaaKoulutus.vue?vue&type=script&lang=js&"
export * from "./MuokkaaKoulutus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports